import moment from 'moment';

const sortDates = (a, b) => {
  if (a === undefined) return 1;
  if (b === undefined) return -1;
  return a.diff(b);
};

export const sortAlphabetically = (a, b) => {
  const start = a || '';
  const end = b || '';

  return start.localeCompare(end);
};

export const sortByDate = (a, b) => {
  const start = a ? moment(a) : undefined;
  const end = b ? moment(b) : undefined;

  return sortDates(start, end);
};

export const sortNumerically = (a, b) => {
  const aValNum = Number(a);
  const bValNum = Number(b);

  const start = isNaN(aValNum) ? 0 : aValNum;
  const end = isNaN(bValNum) ? 0 : bValNum;

  return start - end;
};

const getValue = (obj, keyPath) => {
  if (Array.isArray(keyPath)) {
    return keyPath.reduce((current, k) => current?.[k], obj);
  }
  if (typeof keyPath === 'string' && keyPath.includes('.')) {
    return keyPath.split('.').reduce((current, k) => current?.[k], obj);
  }
  return obj?.[keyPath];
};

export const generateFilters = (data, key, nameKey) => {
  if (!data || data?.length === 0) return [];

  const filtersMap = new Map();

  data.forEach((element) => {
    const findValue = getValue(element, key);
    if (!findValue) return;

    const value = filtersMap.get(getValue(element, key));

    value
      ? filtersMap.set(getValue(element, key), {
          ...value,
          count: value.count + 1,
        })
      : filtersMap.set(getValue(element, key), {
          name: getValue(element, nameKey),
          value: getValue(element, key),
          count: 1,
        });
  });

  return Array.from(filtersMap.values()).sort((a, b) => b.count - a.count);
};

export const disabledDate = (current) => {
  return current && current > moment().endOf('day');
};
